import { useState } from 'react'
import { Dropdown } from 'antd'
import { GlobalOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { SUPPORTED_LANGS, type SupportedLang } from '@/i18n'

function LanguageSwitcher() {
  const { i18n, t } = useTranslation()
  const [open, setOpen] = useState(false)
  const current = (
    SUPPORTED_LANGS.includes(i18n.language as SupportedLang)
      ? i18n.language
      : 'zh-CN'
  ) as SupportedLang

  const handleSelect = (lng: SupportedLang) => {
    void i18n.changeLanguage(lng)
    setOpen(false)
  }

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      open={open}
      onOpenChange={setOpen}
      dropdownRender={() => (
        <div className="hdr-popover">
          <ul className="hdr-popover-list">
            {SUPPORTED_LANGS.map((lng) => {
              const active = lng === current
              return (
                <li key={lng}>
                  <button
                    type="button"
                    className={`hdr-popover-item${active ? ' hdr-popover-item--active' : ''}`}
                    onClick={() => handleSelect(lng)}
                  >
                    {t(`lang.${lng}` as const)}
                  </button>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    >
      <button
        type="button"
        className="hdr-tool-btn"
        aria-label={t('lang.label')}
      >
        <GlobalOutlined style={{ fontSize: 18 }} />
      </button>
    </Dropdown>
  )
}

export default LanguageSwitcher
